import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <div className="relative w-full max-w-3xl aspect-[16/7] rounded-2xl overflow-hidden mb-10">
            <img
              src="https://readdy.ai/api/search-image?query=A%20grand%20dramatic%20competition%20stage%20with%20multiple%20spotlights%20creating%20a%20circular%20illumination%20pattern%2C%20red%20velvet%20curtains%20draped%20elegantly%2C%20a%20large%20golden%20text%20reading%20daily%20reveal%20competition%20in%20the%20center%2C%20cinematic%20atmosphere%2C%20theatrical%20lighting%20with%20warm%20golden%20and%20crimson%20tones%2C%20clean%20elegant%20composition%2C%20editorial%20photography%20style&width=1200&height=525&seq=cta-dasai-entry&orientation=landscape"
              alt="每日黑料大赛入口"
              title="每日黑料大赛入口 - 每日黑料吃瓜网"
              className="w-full h-full object-cover object-top rounded-2xl"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent rounded-2xl"></div>
          </div>

          <p className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 leading-relaxed max-w-2xl">
            每日黑料大赛入口已开启，
            <span className="text-primary-500 italic">为你心中的</span>
            <br />
            「塌房之王」投出关键一票
          </p>

          <Link
            to="/category/meiri-dasai"
            className="mt-8 px-8 py-3.5 bg-foreground-900 text-background-50 text-base font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            立即进入每日黑料大赛
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}